import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, InputSignal, OutputEmitterRef, input, output } from '@angular/core';

import {
  TiimePropertyDirective,
  TiimeLargePropertyDirective,
  TiimePropertiesDirective,
  TiimeIconPropertyDirective,
  TiimeIconModule,
  TiimeTooltipModule,
  TiimeButtonModule
} from 'tiime-material';

import { Company } from '@models/company';

@Component({
  selector: 'app-prospect-company-container',
  standalone: true,
  imports: [
    CommonModule,
    TiimeTooltipModule,
    TiimePropertyDirective,
    TiimeLargePropertyDirective,
    TiimeIconPropertyDirective,
    TiimeButtonModule,
    TiimeIconModule
  ],
  templateUrl: './prospect-company-container.component.html',
  styleUrls: ['./prospect-company-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [TiimePropertiesDirective]
})
export class ProspectCompanyContainerComponent {
  readonly company: InputSignal<Company> = input.required<Company>();
  readonly createCompanyDisabled: InputSignal<boolean> = input.required<boolean>();
  readonly createCompanyTooltip: InputSignal<string> = input.required<string>();
  readonly displayNavigateToCompany: InputSignal<boolean> = input<boolean>(false);

  readonly navigateToCompany: OutputEmitterRef<void> = output<void>();
  readonly createCompany: OutputEmitterRef<void> = output<void>();

  emitNavigateToCompany(): void {
    this.navigateToCompany.emit();
  }

  emitCreateCompany(): void {
    this.createCompany.emit();
  }
}
